import bear from "./../sounds/bear.ogg";
import elephant from "./../sounds/elephant.ogg";
import giraffe from "./../sounds/giraffe.ogg";
import hippo from "./../sounds/hippo.ogg";
import kangaroo from "./../sounds/kangaroo.ogg";
import lion from "./../sounds/lion.ogg";
import monkey from "./../sounds/monkey.ogg";
import penguin from "./../sounds/penguin.ogg";
import snake from "./../sounds/snake.ogg";
import tiger from "./../sounds/tiger.ogg";
import tortoise from "./../sounds/tortoise.ogg";
import zebra from "./../sounds/zebra.ogg";
import butterfly from "./../sounds/butterfly.ogg";
import spider from "./../sounds/spider.ogg";

export const animals = [
    {
      title: "giraffe",
      polish: "żyrafa",
      image:
        "https://images.unsplash.com/photo-1516749744210-1981409bd921?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=752&q=80",
        sounds: giraffe,
    },
    {
      title: "elephant",
      polish: "słoń",
      image:
        "https://images.unsplash.com/photo-1454249649614-b7c89c0e6b22?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80",
        sounds: elephant,
    },
    {
      title: "bear",
      polish: "niedźwiedź",
      image:
        "https://images.unsplash.com/photo-1589656966895-2f33e7653819?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=750&q=80",
        sounds: bear,
    },
    {
      title: "hippo",
      polish: "hipopotam",
      image:
        "https://images.unsplash.com/photo-1580661442800-a0c2662cbcbe?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=750&q=80",
        sounds: hippo,
    },
    {
      title: "kangaroo",
      polish: "kangur",
      image:
        "https://images.unsplash.com/photo-1575699914911-0027c7b95fb6?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=751&q=80",
        sounds: kangaroo,
    },
    {
      title: "lion",
      polish: "lew",
      image:
        "https://images.unsplash.com/photo-1552410260-0fd9b577afa6?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80",
        sounds: lion,
    },
    {
      title: "monkey",
      polish: "małpa",
      image:
        "https://images.unsplash.com/photo-1578013450872-7691b2c5f95a?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=750&q=80",
        sounds: monkey,
    },
    {
      title: "penguin",
      polish: "pingwin",
      image:
        "https://images.unsplash.com/photo-1462888210965-cdf193fb74de?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=667&q=80",
        sounds: penguin,
    },
    {
      title: "snake",
      polish: "wąż",
      image:
        "https://images.unsplash.com/photo-1585095595205-e68428a9e205?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=750&q=80",
        sounds: snake,
    },
    {
        title: "tiger",
        polish: "tygrys",
        image:
          "https://images.unsplash.com/photo-1551972251-12070d63502a?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=667&q=80",
          sounds: tiger,
      },
      {
        title: "tortoise",
        polish: "żółw",
        image:
          "https://images.unsplash.com/photo-1508455858334-95337ba25607?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=755&q=80",
          sounds: tortoise,
      },
      {
        title: "zebra",
        polish: "zebra",
        image:
          "https://images.unsplash.com/photo-1526319238109-524eecb9b913?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=710&q=80",
          sounds: zebra,
      },
      {
        title: "butterfly",
        polish: "motyl",
        image:
          "https://images.unsplash.com/photo-1547990338-943dc0c27796?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=748&q=80",
          sounds: butterfly,
      },
      {
        title: "spider",
        polish: "pająk",
        image:
          "https://images.unsplash.com/photo-1536872962188-fbb2ec963019?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=801&q=80",
          sounds: spider,
      },
  ];